import React from "react";
import {
  LatePaymentIcon,
  TrackingDifficultyIcon,
  ManualWorkIcon,
  DisorganizationIcon,
} from "./icons/SvgIcons";

const problems = [
  {
    icon: LatePaymentIcon,
    title: "Late rent payments",
    text: "Tenants forget, and chasing them wastes your time and strains relationships.",
  },
  {
    icon: TrackingDifficultyIcon,
    title: "Hard to track who paid",
    text: "Spreadsheets and notebooks make it easy to lose track of payments across properties.",
  },
  {
    icon: ManualWorkIcon,
    title: "Too much manual work",
    text: "Writing receipts, sending reminders, and calculating balances by hand is exhausting.",
  },
  {
    icon: DisorganizationIcon,
    title: "Disorganised records",
    text: "Scattered tenant data across phones, books and WhatsApp groups leads to disputes.",
  },
];

export default function ProblemSection() {
  return (
    <section className="border-b border-gray-100 bg-gray-50 py-16 dark:border-gray-800 dark:bg-gray-900 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
            Managing rent shouldn't be this hard
          </h2>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-400">
            Most landlords deal with the same frustrations every single month.
          </p>
        </div>
        <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {problems.map((p) => (
            <div
              key={p.title}
              className="rounded-2xl border border-gray-200 bg-white p-6 transition-shadow duration-200 hover:shadow-md dark:border-gray-700 dark:bg-gray-800"
            >
              <p.icon size={56} bg="#FEF2F2" />
              <h3 className="mt-4 text-base font-semibold text-gray-900 dark:text-white">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-gray-600 dark:text-gray-400">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
